import { useState, type FormEvent } from 'react'
import { Link, Navigate, useLocation } from 'react-router-dom'
import Logo from '../components/Logo'
import { Button, Field } from '../components/ui'
import { api } from '../lib/api'
import { useAuth } from '../lib/useAuth'

export default function RequestInvite() {
  const { user, loading } = useAuth()
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [website, setWebsite] = useState('')
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (busy) return
    setBusy(true)
    setError('')
    try {
      await api.requestInvite({ email: email.trim(), title: title.trim() || null,
        message: message.trim() || null, website })
      setSent(true)
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Could not send your request. Please try again.')
    } finally { setBusy(false) }
  }

  if (loading) return <div className="auth splash"><Logo size={46} /><span className="spinner" /></div>
  if (user) return <Navigate to="/" replace />

  return <main className="auth"><div className="auth-card">
    <Logo size={44} className="auth-logo" />
    <div className="stack auth-titles"><p className="platform-eyebrow">INVITATION-ONLY ACCESS</p>
      <h1>{sent ? 'Request received' : 'Request your invitation'}</h1>
      <p className="muted">TalariCloud account creation and use are currently by invitation.</p>
    </div>
    {sent ? <div className="stack" role="status"><p>An operator will review your request. If approved, you’ll receive a private invitation link with onboarding instructions at the email you provided.</p><p className="tiny muted">This request does not create an account or grant access.</p></div> : <form className="stack" onSubmit={submit}>
      <Field label="Email" htmlFor="invite-email"><input id="invite-email" type="email" autoComplete="email" required maxLength={254} value={email} onChange={event => setEmail(event.target.value)} /></Field>
      <Field label="What are you building? (optional)" htmlFor="invite-title"><input id="invite-title" maxLength={120} value={title} onChange={event => setTitle(event.target.value)} /></Field>
      <Field label="Anything else? (optional)" htmlFor="invite-message"><textarea id="invite-message" rows={4} maxLength={2000} value={message} onChange={event => setMessage(event.target.value)} /></Field>
      <div hidden aria-hidden="true"><label>Website<input name="website" tabIndex={-1} autoComplete="off" value={website} onChange={event => setWebsite(event.target.value)} /></label></div>
      {error && <p className="alert error" role="alert">{error}</p>}
      <Button type="submit" variant="primary" loading={busy} disabled={busy}>Request invitation</Button>
      <p className="tiny muted">Requests are reviewed by an operator. Approval and account access are not automatic.</p>
    </form>}
    <p style={{ marginTop: 24 }}>Already have an account? <Link to="/login" state={location.state}>Sign in</Link></p>
    <p className="tiny muted" style={{ marginTop: 12 }}><a href="https://talaricloud.com/experts.html#apply">Apply to the expert program</a> · <a href="https://talaricloud.com">About TalariCloud</a></p>
  </div></main>
}
